const { default: TokenService } = require('../services/TokenService');
const { GraphQLClient } = require('graphql-request');

export const endPoint = window['env']['graphqlBaseUrl'];
// export const endPoint = process.env.REACT_APP_MERCHANT_SERVICE;
const appToken = 'Bearer ' + TokenService.getLocalAppToken();
export const userToken = 'Bearer ' + TokenService.getLocalUserToken();

export const tokenAppGraphql = new GraphQLClient(endPoint);

export const loginServiceGraphql = new GraphQLClient(endPoint, {
  headers: {
    authorization: appToken,
  },
});

export const merchantServiceGraphql = new GraphQLClient(endPoint, {
  headers: {
    authorization: userToken,
  },
});

export const appId = {
  data: {
    // "app_id": process.env.REACT_APP_APP_ID,
    // "secret_key": process.env.REACT_APP_SECRET_KEY
    app_id: window['env']['appId'],
    secret_key: window['env']['secretKey'],
  },
};
